"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var parse_exports = {};
__export(parse_exports, {
  loadGroupFile: () => loadGroupFile,
  parseYaml: () => parseYaml
});
module.exports = __toCommonJS(parse_exports);
var import_communication_shared = require("@hcengineering/communication-shared");
var import_communication_types = require("@hcengineering/communication-types");
var import_js_yaml = __toESM(require("js-yaml"));
async function loadGroupFile(workspace, filesUrl, blobId, options) {
  const url = getFileUrl(workspace, filesUrl, blobId);
  const file = await (0, import_communication_shared.retry)(() => fetchFile(url), options);
  return parseYaml(file);
}
__name(loadGroupFile, "loadGroupFile");
async function fetchFile(url) {
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`Failed to fetch file: ${res.statusText}`);
  }
  if (res.body == null) {
    throw new Error("Missing response body");
  }
  return await res.text();
}
__name(fetchFile, "fetchFile");
function getFileUrl(workspace, urlTemplate, file) {
  return urlTemplate.replaceAll(":filename", encodeURIComponent(file)).replaceAll(":workspace", encodeURIComponent(workspace)).replaceAll(":blobId", encodeURIComponent(file));
}
__name(getFileUrl, "getFileUrl");
function parseYaml(data) {
  const [metadata, messages] = import_js_yaml.default.loadAll(data);
  return {
    ...metadata,
    messages: messages.map((message) => ({
      id: message.id,
      type: message.type,
      cardId: metadata.cardId ?? metadata.card,
      content: message.content,
      edited: message.edited,
      creator: message.creator,
      created: message.created,
      removed: message.removed,
      extra: message.extra ?? message.data,
      thread: message.thread != null ? {
        cardId: metadata.cardId,
        messageId: message.id,
        threadId: message.thread.threadId ?? message.thread.thread,
        threadType: message.thread.threadType,
        repliesCount: message.thread.repliesCount,
        lastReply: message.thread.lastReply
      } : void 0,
      attachments: parseAttachments(message),
      reactions: message.reactions ?? []
    }))
  };
}
__name(parseYaml, "parseYaml");
function parseAttachments(message) {
  if (message.attachments != null) {
    return message.attachments;
  }
  const oldMessage = message;
  const attachments = [];
  if ("files" in oldMessage && Array.isArray(oldMessage.files)) {
    attachments.push(
      ...oldMessage.files.map((it) => ({
        id: it.blobId,
        type: it.type,
        params: {
          blobId: it.blobId,
          mimeType: it.type,
          fileName: it.filename,
          size: it.size,
          metadata: it.meta
        },
        creator: it.creator,
        created: new Date(it.created)
      }))
    );
  } else if ("blobs" in oldMessage && Array.isArray(oldMessage.blobs)) {
    attachments.push(
      ...oldMessage.blobs.map((it) => ({
        id: it.blobId,
        type: it.mimeType ?? it.contentType,
        params: {
          blobId: it.blobId,
          mimeType: it.mimeType ?? it.contentType,
          fileName: it.fileName,
          size: it.size,
          metadata: it.metadata
        },
        creator: it.creator,
        created: new Date(it.created)
      }))
    );
  }
  if ("linkPreviews" in oldMessage && Array.isArray(oldMessage.linkPreviews)) {
    attachments.push(
      ...oldMessage.linkPreviews.map((it) => ({
        id: it.previewId,
        type: import_communication_types.linkPreviewType,
        params: it,
        creator: it.creator,
        created: new Date(it.created)
      }))
    );
  }
  return attachments;
}
__name(parseAttachments, "parseAttachments");
//# sourceMappingURL=parse.js.map
